import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const generateLoanPDF = async ({
    customer,
    loans,
    emis,
    payments,
}: any) => {
    const safeNumber = (val: any) => {
        const num = Number(val);
        return isNaN(num) ? 0 : num;
    };

    // ✅ Convert Image URL → Base64 (FIXES PDF IMAGE ISSUE)
    const getBase64 = async (url: string) => {
        try {
            const res = await fetch(url);
            const blob = await res.blob();

            return await new Promise<string>((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result as string);
                reader.readAsDataURL(blob);
            });
        } catch (err) {
            console.error("Image load failed", err);
            return "";
        }
    };

    const doc = new jsPDF();

    let logoBase64 = "";
    let customerImgBase64 = "";
    const companyLogo = "https://admin-panel.vasudevlokafinance.com/assets/logo1.png";

    if (companyLogo) {
        logoBase64 = await getBase64(companyLogo);
    }

    if (customer?.passportSizePhoto) {
        customerImgBase64 = await getBase64(customer.passportSizePhoto);
    }

    if (logoBase64) {
        doc.addImage(logoBase64, "JPEG", 14, 10, 20, 20);
    }

    if (customerImgBase64) {
        doc.addImage(customerImgBase64, "JPEG", 160, 10, 30, 30);
    }

    doc.setFontSize(14);
    doc.text("VASUDEVLOKA MICRO SERVICES FOUNDATION", 50, 15);

    doc.setFontSize(10);
    doc.text("Official Loan Statement", 50, 22);

    doc.line(14, 30, 196, 30);

    doc.setFontSize(12);
    doc.text("Customer Details", 14, 38);

    const customerRows = [
        ["Name", customer?.full_name || "-"],
        ["Phone", customer?.phoneNumber1 || "-"],
        ["Loan Account Number", customer?.loanAccountNumber || "-"],
        ["Aadhar", customer?.aadharNumber || "-"],
        ["PAN", customer?.PanNumber || "-"],
        ["Email", customer?.email || "-"],
    ];

    autoTable(doc, {
        startY: 42,
        body: customerRows,
        theme: "grid",
    });

    // ================= LOAN =================
    autoTable(doc, {
        startY: (doc as any).lastAutoTable.finalY + 10,
        head: [["Loan ID", "Amount", "EMI", "Total", "Balance"]],
        body: (loans || []).map((l: any) => {
            const emiAmount = safeNumber(l?.emis?.emis?.[0]?.amount);
            const totalEmis = safeNumber(l?.numberOfEmis);

            const total = emiAmount * totalEmis;

            const paid =
                l?.emis?.payments?.reduce(
                    (t: number, p: any) => t + safeNumber(p?.paymentAmount) +
                        safeNumber(p?.discount),
                    0
                ) || 0;

            return [
                l?.loan_id || "-",
                safeNumber(l?.approvalAmount),
                emiAmount,
                total,
                total - paid,
            ];
        }),
        theme: "striped",
    });

    // ================= EMI =================
    if (emis?.length) {
        autoTable(doc, {
            startY: (doc as any).lastAutoTable.finalY + 10,
            head: [["EMI No", "Amount", "Due Date", "Status"]],
            body: emis.map((e: any) => [
                e?.id || "-",
                safeNumber(e?.amount),
                e?.due_date || "-",
                e?.status || "-",
            ]),
            theme: "striped",
        });
    }

    // ================= PAYMENTS =================
    if (payments?.length) {
        autoTable(doc, {
            startY: (doc as any).lastAutoTable.finalY + 10,
            head: [["Date", "Amount", "Penalty", "Mode", "Receipt"]],
            body: payments.map((p: any) => [
                p?.payment_date || "-",
                safeNumber(p?.paymentAmount),
                safeNumber(p?.penaltyAmount),
                p?.paymentMode || "-",
                p?.receipt_number || "-",
            ]),
            theme: "striped",
        });
    }

    // ================= FOOTER =================
    const finalY = (doc as any).lastAutoTable.finalY + 20;

    doc.setFontSize(10);
    doc.text("Authorized Signature", 150, finalY);

    doc.line(140, finalY - 5, 200, finalY - 5);

    // ================= SAVE =================
    doc.save(`Loan-${customer?.full_name || "Statement"}.pdf`);
};